module.exports = __webpack_public_path__ + "img/supplySolutions5.1756b34a.png";